import React from 'react';
import { SubNavigationSidebar } from 'components/SubNavigationSidebar';
import TwoColumnsCardSidebar from 'components/TwoColumnsCardSidebar';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { routes } from 'containers/routes';
import { MenuItemProps } from 'components/NavLink/MenuItem';
import { ParseKeys } from 'i18next';
import { useTranslation } from 'react-i18next';
import {
  ClipboardDocumentListIcon as ClipboardList,
  KeyIcon as Key,
  MapPinIcon as LocationMarker,
  RectangleStackIcon as Collection,
  ShareIcon as Share,
  SwatchIcon as ColorSwatch,
  UsersIcon as Users,
} from '@heroicons/react/24/outline';
import { Schoolyear } from 'types/schoolyear';
import { School } from 'types/school';

type I18nTitleKey = Extract<
  ParseKeys<'schoolyearSettings', {}, undefined>,
  `schoolSubmenu.${string}`
>;
const menuItems: (Omit<MenuItemProps, 'title'> & { title: I18nTitleKey })[] = [
  {
    route: 'general',
    icon: ClipboardList,
    title: 'schoolSubmenu.general',
  },
  {
    route: 'org',
    icon: Collection,
    title: 'schoolSubmenu.org',
  },
  {
    route: 'tags',
    icon: ColorSwatch,
    title: 'schoolSubmenu.tags',
  },
  {
    route: 'coordonnees',
    icon: LocationMarker,
    title: 'schoolSubmenu.coordonnees',
  },
  {
    route: 'contacts',
    icon: Users,
    title: 'schoolSubmenu.contacts',
  },
  {
    route: 'codes',
    icon: Key,
    title: 'schoolSubmenu.codes',
  },
  {
    route: 'share',
    icon: Share,
    title: 'schoolSubmenu.share',
  },
];

interface Props {
  className?: string;
}

export function Sidebar(props: Props) {
  const { school, schoolyear } = useOutletContext<{
    schoolyear: Schoolyear;
    school: School;
  }>();
  const { t } = useTranslation(['schoolyearSettings']);
  const navigate = useNavigate();
  const location = useLocation();
  const route = location.pathname.split('/')[3];

  return (
    <TwoColumnsCardSidebar.Side className={props.className}>
      <SubNavigationSidebar
        items={menuItems.map(i => ({
          ...i,
          title: t(i.title),
          route: `${routes.schoolBase({
            schoolyearId: schoolyear.id,
            schoolId: school.id,
          })}/${i.route}`,
        }))}
        goTo={navigate}
        currentRoute={`${routes.schoolBase({
          schoolyearId: schoolyear.id,
          schoolId: school.id,
        })}/${route}`}
      />
    </TwoColumnsCardSidebar.Side>
  );
}
